import React from 'react';
import StatisticsPage from '../components/supplierStats/StatisticsPage';
export default function SupplierStatsDashboard() {
  return <StatisticsPage kind="dashboard" />;
}
